/***
 * Created on 2023/8/10
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import {useTranslation} from "react-i18next";
import ModalDialog from "../../common/modal_dialog/modalDialog";
import warning_svg from '../../../static/img/utils/ic-sys-warning.svg';


function FailOverLimitDialog(props) {
    const { t } = useTranslation();

    return (
        <ModalDialog {...props} title={t('@GENERAL_SESSION_EXPIRED@')} submitText={t('@Sign in again@')} hideCancel={true}>
            <div className="dialog-content dialog-content--alert">
                <div className="dialog-content--alert__icon">
                    <img src={warning_svg} alt=""/>
                </div>
                <div className="dialog-content--alert__content">
                    <div className="dialog__title">{t('@GENERAL_SESSION_EXPIRED@')}</div>
                    <p>
                        {t('@You are being signed out due to several incorrect password attempts.@')}
                    </p>
                </div>
            </div>

        </ModalDialog>
    );
}

export default FailOverLimitDialog;